// include the library
const tag = document.createElement('script')
tag.src = "https://www.youtube.com/iframe_api"
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

window.AboundYoutubeAutoplay = (iframeElId) => {
    if(!IntersectionObserver) return

    window.addEventListener('load', () => {
        const manager = (() => {
            let isDisabled = false
            let isLoaded = false
            let isInView = false
            let lastKnownState

            return {
                getLastKnownState: () => {
                    return lastKnownState
                },
                disable: () => {
                    isDisabled = true
                },
                play: (player) => {
                    if(isDisabled) return
                    if(!isInView) return
                    if(!isLoaded) return

                    lastKnownState = YT.PlayerState.PLAYING

                    player.playVideo()
                },
                loaded: () => {
                    isLoaded = true
                },
                pause: (player) => {
                    if(isDisabled) return
                    if(!isLoaded) return

                    lastKnownState = YT.PlayerState.PAUSED

                    player.pauseVideo()
                },
                inView: () => {
                    isInView = true
                },
                outOfView: () => {
                    isInView = false
                },
            }
        })()

        const iframeEl = document.getElementById(iframeElId)
        if(!iframeEl) return

        const player = new YT.Player(iframeElId, {
            events: {
                'onReady': () => {
                    manager.loaded()
                    manager.play(player)
                },
                // detect if user made a change (play or pause). if they did, we no longer want to automatically play/pause the video
                'onStateChange': (e) => {
                    const state = e.data
                    const lastKnownState = manager.getLastKnownState()

                    if(state !== YT.PlayerState.PAUSED && state !== YT.PlayerState.PLAYING && state !== YT.PlayerState.ENDED) return
                    if(!lastKnownState) return

                    // will know the user made the change if the state is different from what the manager knows
                    if(state !== lastKnownState) manager.disable()
                },
            },
        })

        const threshold = 0.4

        const observer = new IntersectionObserver((entries, observer) => {
            if(!entries || !entries.length) return
            const entry = entries[0]

            if(entry.intersectionRatio >= threshold) {
                manager.inView()
                manager.play(player)
            }
            else {
                manager.outOfView()
                manager.pause(player)
            }
        }, {
            threshold,
        })

        observer.observe(iframeEl)
    })
}



// WEBPACK FOOTER //
// ./youtube-autoplay.js